import { QUOTE_RELANCE_MAX_DAYS } from '@shared/quote-relance.js'
import { QuoteStatus, normalizeQuoteStatus } from '../constants/quote.js'
import { parisDayLabel, addDaysToLabel } from './parisCalendar.js'

/**
 * Dernier jour (Paris, 'YYYY-MM-DD') où une relance téléphonique garde un sens :
 * la veille du passage automatique en « Devis perdu » si le devis est parti,
 * sinon aujourd'hui + 29. Miroir de `relanceMaxDayLabel` côté serveur
 * (services/quotes/quote-relance-schedule.service.js), qui tranche.
 */
export const devisEnvoye = (quote) =>
  normalizeQuoteStatus(quote?.status) === QuoteStatus.DEVIS_EN_ATTENTE && Boolean(quote?.quote_sent_date)

export function relanceMaxDayLabel(quote, now = new Date()) {
  return addDaysToLabel(parisDayLabel(devisEnvoye(quote) ? quote.quote_sent_date : now), QUOTE_RELANCE_MAX_DAYS)
}

/** La date saisie (champ datetime-local) tombe-t-elle après le dernier jour ? */
export function relanceTropTardive(dueDateLocal, dernierJour) {
  if (!dueDateLocal || !dernierJour) return false
  const saisie = new Date(dueDateLocal)
  return !isNaN(saisie) && parisDayLabel(saisie) > dernierJour
}

/** Le devis passe en « Devis perdu » aujourd'hui : plus aucune date n'est possible. */
export const relanceImpossible = (dernierJour, now = new Date()) => Boolean(dernierJour) && dernierJour < parisDayLabel(now)

export const formatDayLabelFr = (label) => label.split('-').reverse().join('/')
